import { fromJS } from 'immutable';
import { dueActivitiesCount } from './types';

export * from './actions';

const dueActivitiesCountReducerObject = {
  [dueActivitiesCount.success]: (state, action) =>
    state.mergeIn(['fundingSearchDueActivitiesCount'], fromJS(action.response)),
};

export default dueActivitiesCountReducerObject;
